<template>
  <a-modal
    title="设置老师"
    :maskClosable="false"
    :width="800"
    :visible="visible"
    :cancelText="'取消'"
    :okText="'确定'"
    @ok="handleSubmit"
    @cancel="handleCancel"
  >
    <a-form layout="horizontal" :form="form">
      <a-form-item
        label="当前主讲老师"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 17 } }"
      >
        <div class="teacherShow" v-show="this.updateData.teacherName">
          <span class="teacherFrom"
            >{{ this.updateData.teacherName }}&nbsp;&nbsp;&nbsp;&nbsp;{{
              this.updateData.sourceTypeText
            }}</span
          >
          <a
            class="remove"
            v-show="this.updateData.canBeRemove"
            @click="removeTeacher"
            >移除</a
          >
        </div>
        <div class="teacherShow" v-show="!this.updateData.teacherName">无</div>
      </a-form-item>
      <!-- 老师 -->
      <a-form-item
        label="选择更换主讲老师"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 17 } }"
      >
        <a-select
          showSearch
          allowClear
          placeholder="请选择"
          @change="handleChangename"
          @search="searchTeacher($event,1)"
          :filterOption="filterOption"
          :notFoundContent="searchTeacherLoading ? undefined : '没有查询结果'"
          :value="this.updateData.nowTeacherId"
        >
          <a-spin
            v-if="searchTeacherLoading"
            slot="notFoundContent"
            size="small"
          />
          <a-select-option
            v-for="(item, index) in mainTeacherList"
            :key="index"
            :value="item.userId.toString()"
            :disabled="item.disabled"
            >{{ item.nickName }}</a-select-option
          >
        </a-select>
      </a-form-item>
      <a-form-item
        label="当前助教老师"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 17 } }"
      >
        <div
          class="teacherShow"
          v-for="(item, index) in updateData.assistantTeacherList"
          :key="index"
        >
          <span class="teacherFrom"
            >{{ item.nickName }}&nbsp;&nbsp;&nbsp;&nbsp;{{
              item.sourceTypeText
            }}</span
          >
          <a
            class="remove"
            v-show="item.canBeRemove"
            @click="removeAssistantTeacher(item)"
            >移除</a
          >
        </div>
        <div
          class="teacherShow"
          v-show="this.updateData.assistantTeacherList == 0"
        >
          无
        </div>
      </a-form-item>
      <a-form-item
        label="选择添加助教老师"
        :labelCol="{ lg: { span: 7 } }"
        :wrapperCol="{ lg: { span: 17 } }"
      >
        <a-select
          showSearch
          mode="multiple"
          placeholder="请选择"
          @search="searchTeacher($event,2)"
          :filterOption="filterOption"
          :notFoundContent="searchTeacherLoading ? undefined : '没有查询结果'"
          @change="handleChange"
          @blur="handBlur"
          :value="selectedItems"
        >
          <a-spin
            v-if="searchTeacherLoading"
            slot="notFoundContent"
            size="small"
          />
          <a-select-option
            v-for="(item, index) in teacherList"
            :key="index"
            :value="item.userId.toString()"
            :disabled="item.disabled || item.status !== 1"
            class="option-show"
            >{{ item.nickName }}</a-select-option
          >
        </a-select>
        <span v-if="verifyError" class="errorContent">{{ verifyError }}</span>
        <div class="pay-atttention" v-if="roleId != 4">
        注意：班级一个课节，仅支持一个主讲老师+一个助教老师 签到打卡。如设置多个助教老师，其中一个助教老师在一个课节上签到打卡后，其他助教老师则不能在这个课节上进行签到打卡。
      </div>
      </a-form-item>
      <!-- :class="{ 'option-show': item.display && item.display === false }" -->
    </a-form>
  </a-modal>
</template>

<script>
import teacher from '../../api/teacher'

import classSet from '../../api/classSet'
export default {
  name: 'classTeacherModal',
  data() {
    return {
      selectedItems: [],
      visible: false,
      form: this.$form.createForm(this),
      isAdd: true,
      classId: '', //班级ID
      updateData: { nowTeacherId: '' },
      mainTeacherList: [], //主讲老师列表
      teacherList: [], //老师列表
      searchTeacherLoading: false, //搜索老师loading
      removeAssTeacherIds: [], //移除的助教老师

      removeTeacherId: '', //移除的主讲老师

      teacherContent: '', // 输入老师的长文本 用于老师的长文本识别
      verifyError: '', // 验证异常信息
      roleId:-1
    }
  },
  methods: {
    //移除主讲老师
    removeTeacher() {
      this.removeTeacherId = this.updateData.teacherId
      this.updateData.teacherId = ''
      this.updateData.teacherName = ''
    },
        //是否有操作权限
        judgeIsOper() {
      this.$store.dispatch('getUserInfo').then((res) => {
        //只有课程方，学校、平台才有权限
        let roleId = res.accRole.id.toString()
        this.roleId = roleId
      })
    },
    //移除助教老师
    removeAssistantTeacher(msg) {
      this.removeAssTeacherIds.push(msg.userId)
      this.updateData.assistantTeacherList =
        this.updateData.assistantTeacherList.filter((item) => {
          if (item.userId != msg.userId) {
            return item
          }
        })
    },
    handleChangename(val) {
      this.updateData.nowTeacherId = val
      this.teacherList.forEach((item) => {
        if (item.userId == val) {
          item.disabled = true
        } else {
          item.disabled = false
        }
      })
    },
    handleChange(selectedItems) {
      this.selectedItems = selectedItems
      this.teacherContent = ''
      this.verifyError = ''
      this.mainTeacherList.forEach((item, index) => {
        if (selectedItems.includes(item.userId.toString())) {
          this.mainTeacherList[index] = { ...item, disabled: true }
        }
      })
    },
    //搜索老师
    searchTeacher(val = '', type) {
      this.teacherContent = val
      this.searchTeacherLoading = true
      let req = {
        pageSize: 500,
        keyword: val.trim(),
      }
      if (type == 1) {
        req.courseId = this.updateData.courseId
      } else {
        req.courseId = ''
      }
      teacher.getTeacherList(req).then((res) => {
        this.searchTeacherLoading = false
        if (type == 1) {
          let mainTeacherList = res.data.list
          this.mainTeacherList = mainTeacherList.map((item) => {
            if (
              this.updateData.assistantTeacherList
                .map((item) => item.userId)
                .includes(item.userId) ||
              item.userId == this.updateData.teacherId
            ) {
              return { ...item, disabled: true }
            } else {
              return { ...item, disabled: false }
            }
          })
        } else {
          let teacherList = res.data.list
          this.teacherList = teacherList.map((item) => {
            if (
              this.updateData.assistantTeacherList
                .map((item) => item.userId)
                .includes(item.userId) ||
              item.userId == this.updateData.teacherId
            ) {
              return { ...item, disabled: true }
            } else {
              return { ...item, disabled: false }
            }
          })
        }
      })
    },
    filterOption(value, option) {
      return option.componentOptions.children[0].text.indexOf(value) >= 0
    },

    //初始化，显示
    init(params) {
      console.log('params', params)
      this.visible = true

      this.updateData = { ...params, nowTeacherId: '' }

      //加载初始化码表
      this.searchTeacher('', 1)
      this.searchTeacher('', 2)

      let formData = {}
      formData.teacherId = params.teacherId ? params.teacherId.toString() : ''
      formData.assistantTeacherId = params.assistantTeacherId
        ? params.assistantTeacherId.toString()
        : ''
      //记录当前教室的ID
      this.classId = params.id
      setTimeout(() => {
        this.form.setFieldsValue(formData)
      }, 100)
      this.judgeIsOper()
    },

    //隐藏
    handleCancel() {
      this.visible = false
      this.updateData = {}
      this.selectedItems = []
      this.removeAssTeacherIds = []
      this.removeTeacherId = ''
      this.teacherContent = ''
      this.verifyError = ''
    },

    //提交表单
    handleSubmit(e) {
      e.preventDefault()
      this.form.validateFields((err, value) => {
        //校验通过
        if (!err) {
          this.arrangeTeacher(value)
        }
      })
    },

    //安排老师
    arrangeTeacher(value) {
      let flag = true
      let teacherId
      if (this.updateData.nowTeacherId) {
        teacherId = this.updateData.nowTeacherId
      } else if (!this.updateData.nowTeacherId && this.updateData.teacherId) {
        teacherId = this.updateData.teacherId
      } else if (!this.updateData.nowTeacherId && !this.updateData.teacherId) {
        teacherId = ''
      }

      this.selectedItems.forEach((item) => {
        if (teacherId == item) {
          flag = false
          return this.$message.error('主讲老师和助教老师不能是同一人')
        }
      })
      if (flag) {
        let req = {
          id: this.classId,
          teacherId:
            this.updateData.nowTeacherId != undefined
              ? this.updateData.nowTeacherId
              : '',
          assistantTeacherId: this.selectedItems.join(','),
          removeAssTeacherIds: this.removeAssTeacherIds,
          removeTeacherId: this.removeTeacherId,
        }
        classSet.arrangeTeacher(req).then((res) => {
          this.$message.success('修改成功')
          this.searchTeacher('', 1)
          this.searchTeacher('', 2)
          //前端列表回显老师列表
          this.$parent.pageRefresh()
          this.$set(this.updateData, 'teacherName', res.data.nickName)
          this.visible = false
          this.updateData = {}
          this.updateData.nowTeacherId = ''
          this.selectedItems = []
          this.removeAssTeacherIds = []
          this.removeTeacherId = ''
        })
      }
    },
    handBlur() {
      this.searchTeacherLoading = true

      const teacherContent = this.teacherContent
      let params = { teachers: teacherContent }
      if (teacherContent.length) {
        teacher.verifyTeacher(params).then((res) => {
          const data = res.data
          this.searchTeacherLoading = false
          if (data.verified.length) {
            let ids = []
            // 去重
            data.verified.forEach((i) => ids.push(i.userId.toString()))
            let selectedItems = [...this.selectedItems, ...ids]
            let resList = [...new Set(selectedItems)]
            // 过滤已选择的主讲老师
            let z = resList.findIndex((i) => i == this.updateData.teacherId)
            if (z != -1) resList.splice(z, 1)
            // 过滤已选择的助教老师
            if (this.updateData.assistantTeacherList.length) {
              this.updateData.assistantTeacherList.forEach((i) => {
                let r = resList.findIndex((j) => j == i.userId)
                if (r != -1) resList.splice(r, 1)
              })
            }
            this.selectedItems = resList
          }
          // 提示错误信息
          if (data.duplicate.length && data.failed.length)
            this.verifyError = `无法匹配到对应老师：${data.failed},如下老师信息存在重复无法唯一选中：${data.duplicate}`
          else if (data.duplicate.length)
            this.verifyError = `如下老师信息存在重复无法唯一选中：${data.duplicate}`
          else if (data.failed.length)
            this.verifyError = `无法匹配到对应老师：${data.failed}`
          else this.verifyError = ''
          this.teacherContent = ''
          this.searchTeacher('', 1)
          this.searchTeacher('', 2)
        })
      } else {
          this.searchTeacherLoading = false
      }
    }
  },
  created() {},
}
</script>
<style lang="scss" scoped>
@import 'src/config/var';
.teacherShow {
  display: flex;
  justify-content: space-between;
  margin-left: 10px;
  .teacherFrom {
    margin-left: 10px;
    margin-right: 15px;
  }
}
.remove {
  color: #178fff;
  width: 45px;
}
.errorContent {
  color: #f5222d;
}
.pay-atttention{
  line-height: 28px;
  color: red;
}
</style>
